export default [
    {
        id: 1,
        descripcion: 'SORTEO'
    },
    {
        id: 2,
        descripcion: 'TURNO'
    },
    {
        id: 3,
        descripcion: 'EJECUCIÓN'
    },
    {
        id: 4,
        descripcion: 'INTERVINIENTE'
    },
    {
        id: 5,
        descripcion: 'SORTEO/MENOR'
    },
    {
        id: 6,
        descripcion: 'SORTEO BALANCE 1'
    },
    {
        id: 7,
        descripcion: 'MANUAL'
    },
    {   
        id: 8,
        descripcion: 'RESORTEO'
    }
]